import { Platform } from '../models/Platform';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

interface PlatformState extends ApiState {
  platforms?: Platform[]
}

export default requestReducer<PlatformState>('PLATFORM_LIST')